import templateUrl from './pay-stub.component.html'
import './pay-stub.component.less'

export const PayStubComponent = {
    templateUrl,
    bindings: {
        payStub: "<",
        useDailyRsCommission: "<"
    },
    controllerAs: "vm",
    controller: class PayStubController {
        $onInit() {

        }
    }
}
